import PropTypes from 'prop-types';

const StatItem = ({ value, label }) => {
  // Format value to include 'K' if in thousands
  const formattedValue = value >= 1000 ? `${value/1000}K` : value;
  
  return (
    <div className="flex flex-col items-center">
      <div className="w-[70px] h-[70px] border border-primary rounded-[100px] flex items-center justify-center mb-2 p-[10px]">
        <span className="text-bold text-lightGrey">{formattedValue}</span>
      </div>
      <span className="text-small text-lighterGrey">{label}</span>
    </div>
  );
};

StatItem.propTypes = {
  value: PropTypes.number,
  label: PropTypes.string,
};
  
const QuickStats = ({ stats }) => {
  return (
    <div className='2xl:mb-3'>
      <h2 className="mb-6 heading-medium">Quick Stats</h2>
      <div className="grid grid-cols-4 gap-8 mb-6 2xl:grid-cols-2">
        <StatItem value={stats.voters} label="Voters" />
        <StatItem value={stats.competitors} label="Competitors" />
        <StatItem value={stats.winnings} label="Winnings" />
        <StatItem value={stats.losses} label="Losses" />
      </div>
    </div>
  );
};

QuickStats.propTypes = {
  stats: PropTypes.shape({
    voters: PropTypes.number,
    competitors: PropTypes.number,
    winnings: PropTypes.number,
    losses: PropTypes.number,
  }),
};

export default QuickStats;